exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.gis-btn {\n    margin: 5px;\n    padding: 5px 10px;\n    font-size: 12px;\n}\n", ""]);

